import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { TokenResponse } from "@react-oauth/google";
import { RootState } from "../store";
import dayjs from "dayjs";

export interface CredentialProperties {
  credentials: Omit<
    TokenResponse,
    "error" | "error_description" | "error_uri"
  > & { expires: string };
  selectedSheet: string;
}

export const initialState: CredentialProperties = {
  credentials: {
    access_token: "",
    expires_in: 0,
    prompt: "",
    scope: "",
    token_type: "",
    expires: "",
  },
  selectedSheet: "",
};

const credentialsSlice = createSlice({
  name: "credentials",
  initialState,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<CredentialProperties["credentials"]>
    ) {
      state.credentials = action.payload;
      state.credentials.expires = dayjs()
        .add(action.payload.expires_in, "seconds")
        .toISOString();
      state.selectedSheet = "";
    },
    setLogout() {
      return initialState;
    },
    setSelectedSheet(
      state,
      action: PayloadAction<CredentialProperties["selectedSheet"]>
    ) {
      state.selectedSheet = action.payload;
    },
  },
});

export const selectAccessToken = (state: RootState) =>
  dayjs().isAfter(dayjs(state.credentials.credentials.expires))
    ? ""
    : state.credentials.credentials.access_token;

export const selectCredentials = (state: RootState) =>
  state.credentials.credentials;

export const getSelectedSheet = (state: RootState) =>
  state.credentials.selectedSheet;

export const { setCredentials, setLogout, setSelectedSheet } =
  credentialsSlice.actions;
export default credentialsSlice.reducer;
